// SPDX-FileCopyrightText: 2021 - 2022 Dusan Mijatovic (dv4all)
// SPDX-FileCopyrightText: 2021 - 2022 dv4all
// SPDX-FileCopyrightText: 2022 - 2023 Netherlands eScience Center
// SPDX-FileCopyrightText: 2022 Jesús García Gonzalez (Netherlands eScience Center) <j.g.gonzalez@esciencecenter.nl>
// SPDX-FileCopyrightText: 2023 Christian Meeßen (GFZ) <christian.meessen@gfz-potsdam.de>
// SPDX-FileCopyrightText: 2023 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2023 Helmholtz Centre Potsdam - GFZ German Research Centre for Geosciences
//
// SPDX-License-Identifier: Apache-2.0

import useRsdSettings from '~/config/useRsdSettings'
import MarkdownPages from './MarkdownPages'
import CustomLinks from './CustomLinks'
import OrganisationLogo from './OrganisationLogo'
import ContactEmail from './ContactEmail'

export default function AppFooter () {
  const {pages,links,host} = useRsdSettings()

  return (
    <footer className="flex flex-wrap text-primary-content border-t bg-secondary border-base-300">
      <div className="grid grid-cols-1 gap-8 px-4 md:grid-cols-[2fr_1fr] lg:container lg:mx-auto">
        <div className="pt-8 md:py-8">
          <p className="text-lg">
            KIN connects, broadens, deepens, and unlocks knowledge for transitions towards a climate-neutral and climate-resilient society
          </p>
          <ContactEmail email={host?.email} headers={host?.emailHeaders} />
          {/* <div className="py-4"></div> */}
          <div className="w-[10rem] p-2 rounded-md mt-4">
            <OrganisationLogo host={host} />
          </div>

        </div>
        <div className="pb-8 md:py-8 flex flex-col gap-2">
          <MarkdownPages pages={pages ?? []} />
          <CustomLinks links={links ?? []} />
        </div>
      </div>
    </footer>
  )
}
